// deno-lint-ignore-file no-unused-vars
// Strona pojedynczego zadania (/task/:id): breadcrumbs + to samo drzewo co widok główny (tryb focus:
// wiersz zadania jako korzeń + poddrzewo), z topbarem, sidebarem i filtrami działającymi na gałąź.
// Spec: spec/lista-zadan.md → "Widok pojedynczego zadania".
import { h, Fragment } from '../jsx-runtime.ts';
import type { FilterState, ListFilters } from '../types.ts';
import { TasksAPI } from '../api.ts';
import { showToast } from './tmk-toast.tsx';

class TmkTaskDetail extends HTMLElement {
  async render(opts: { taskId: string; mode?: string; filters?: ListFilters; filterState?: FilterState }) {
    let ancestors: { id: string; title: string }[];
    try {
      ancestors = await TasksAPI.ancestors(opts.taskId);
    } catch (err: unknown) {
      showToast('Nie udało się załadować zadania: ' + (err as Error).message, 'error');
      return;
    }

    this.innerHTML = '';
    const container = <div className="task-detail task-detail-focus" /> as HTMLElement;

    // Breadcrumbs: Wszystkie › przodkowie (linki) › bieżące (ostatni element `ancestors`)
    const breadcrumbs = <div className="breadcrumb-bar" /> as HTMLElement;
    // "/?all": jakikolwiek parametr w URL wyłącza automatyczne ładowanie pierwszego zapisanego widoku
    breadcrumbs.appendChild(<button className="breadcrumb-item breadcrumb-home" title="Pełna lista bez filtrów"
      onClick={() => { window.location.href = '/?all'; }}>Wszystkie</button> as HTMLElement);
    for (let i = 0; i < ancestors.length - 1; i++) {
      const crumb = ancestors[i];
      breadcrumbs.appendChild(<span className="breadcrumb-sep">›</span> as HTMLElement);
      breadcrumbs.appendChild(<button className="breadcrumb-item"
        onClick={() => { window.location.href = '/task/' + crumb.id + window.location.search; }}>{crumb.title}</button> as HTMLElement);
    }
    const current = ancestors[ancestors.length - 1];
    if (current) {
      breadcrumbs.appendChild(<span className="breadcrumb-sep">›</span> as HTMLElement);
      breadcrumbs.appendChild(<span className="breadcrumb-item breadcrumb-current">{current.title}</span> as HTMLElement);
      document.title = current.title + ' — Tomkownik';
    }
    container.appendChild(breadcrumbs);

    const taskList = document.createElement('tmk-task-list') as HTMLElement & {
      render: (opts: Record<string, unknown>) => Promise<void>;
    };
    container.appendChild(taskList);
    this.appendChild(container);
    await taskList.render({
      mode: opts.mode ?? 'tree',
      filters: opts.filters ?? {},
      filterState: opts.filterState,
      focusTaskId: opts.taskId,
    });
  }
}

customElements.define('tmk-task-detail', TmkTaskDetail);

export { TmkTaskDetail };
